export default "__VITE_ASSET__CjTu5sxN__"